module.exports = __webpack_public_path__ + "static/img/logo_bg.638667b9.png";